import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ICartConfig } from './models/cart-config.model';
import { CartConfigToken } from './tokens/cart-config.token';
import { LocalCartService } from './services/local-cart.service';
import { RemoteCartService } from './services/remote-cart.service';
import { CartService } from './services/cart.service';
import { CheckoutAddressService } from '~app/modules/checkout/services/checkout-address.service';
import { RemoteAppCartReadService } from '~shared/modules/cart/services/remote-app-cart-read.service';

@NgModule({
  imports: [
    CommonModule
  ],
})
export class CartModule {
  public static forRoot (configFactory: () => ICartConfig): ModuleWithProviders<CartModule> {
    return {
      ngModule: CartModule,
      providers: [
        {
          provide: CartConfigToken,
          useFactory: configFactory,
        },
        LocalCartService,
        RemoteCartService,
        CartService,
        CheckoutAddressService,
        RemoteAppCartReadService,
      ],
    };
  }
}
